<div class="m-2 m-xl-5">
  @if (headerDetails) {
    <app-handler-items-header
      [config]="headerConfig"
      (onOpenDialogFunction)="openDialogFunction()"
      (onReplyRouteNavigate)="replyRouteNavigate()"
      (onPrint)="print()"
      (onValueWarehouse)="valueWarehouse($event)"
      (onDataComboWarehouse)="dataComboWarehouse($event)"
      (onValueTargetWarehouse)="valueTargetWarehouse($event)"
      (onDataComboTargetWarehouse)="dataComboTargetWarehouse($event)"
      (onValueProvider)="valueProvider($event)"
      (onDataComboProvider)="dataComboProvider($event)"
      (onChangesComboPurchaseOrder)="changesComboPurchaseOrder($event)"
      (onDataComboPurchaseOrder)="dataComboPurchaseOrder($event)"
      (onChangesComboWorkOrder)="changesComboWorkOrder($event)"
      (onChangesComboRentalOrder)="changesComboRentalOrder($event)"
      (onValueUser)="valueUser($event)"
      (onDataComboUser)="dataComboUser($event)"
      (receptionDateChange)="receptionDate = $event"
    >
    </app-handler-items-header>
  }

  <div style="display: flex; width: 100%" class="mt-5">
    <div style="flex: 12">
      <cdk-virtual-scroll-viewport
        itemSize="100"
        [ngClass]="acceptButton ? 'example-viewport-50' : 'example-viewport-70'"
        >
        @for (element of itemsData; track element; let i = $index) {
          <app-handler-items-row
            [config]="rowConfig"
            [element]="element"
            [reloadItemVersion]="reloadItemVersions[i]"
            (onValueWarehouseByItem)="valueWarehouseByItem($event, i)"
            (onValueIDItem)="valueIDItem($event, i)"
            (onAddNew)="addNew($event, i)"
            (onKeyUpAmout)="keyUpAmout(i)"
            (onDeleteItemsData)="deleteItemsData(i)"
          >
          </app-handler-items-row>
        }

        @if (view) {
          <div class="d-flex justify-content-center">
            @if (showRemoveItemButton) {
              <button
                [style.visibility]="itemsData.length > 0"
                class="mr-1"
                mat-icon-button
                color="primary"
                (click)="deleteItemsData(-1)"
                >
                <mat-icon>remove</mat-icon>
              </button>
            }
            @if (showAddItemButton) {
              <button
            [style.visibility]="
              this.itemsData.length == 0 ||
              itemsData[itemsData.length - 1].itemInventoryId
            "
                class="ml-1"
                mat-icon-button
                color="warn"
                (click)="handlerAddForm()"
                >
                <mat-icon>add</mat-icon>
              </button>
            }
          </div>
        }
      </cdk-virtual-scroll-viewport>

      @if (acceptButton) {
        <div
          style="display: flex; flex-direction: row; justify-content: center"
          >
          <button
            [disabled]="buttonActive"
            (click)="save()"
            style="width: 70%; margin-top: 50px; align-self: center"
            color="primary"
            class="button-save mat-elevation-z5"
            mat-raised-button
            type="submit"
            >
            {{ labelAcceptButton }}
          </button>
        </div>
      }
    </div>
  </div>
</div>
